import CreateShortlist from '../../components/Rates/CreateShortlist';
import PrioritiseShortlist from '../../components/Rates/PrioritiseShortlist';
import GetApproved from '../../components/Other/GetApproved';

export const STAGE_LOOKUP = {
  'Create Shortlist': CreateShortlist,
  'Prioritise Shortlist': PrioritiseShortlist,
  'Get Approved': GetApproved,
};
